/**
 * Lokalizační klíč pro text "Více hodnot" používaný ve fake komponentách.
 */
export const FAKE_COMPONENT_VALUE_LOC_KEY = "GUI-715304";
/**
 * Lokalizační klíč pro text "Multieditace nepodporována" používaný ve fake komponentách.
 */
export const FAKE_COMPONENT_NOEDIT_VALUE_LOC_KEY = "GUI-721248";
/**
 * Ano
*/
export const YES_LOC_KEY = "GUI-722098";
/**
 * Ne
*/
export const NO_LOC_KEY = "GUI-722099";
/**
 * Opravdu chcete zavřít průvodce?
*/
export const CLOSE_WIZARD_LOC_KEY = "GUI-763622";
/**
 * Zavřít
*/
export const CLOSE_LOC_KEY = "GUI-4447";
